export default __webpack_public_path__ + "static/media/canonesClosed.ec2bd039.jpg";